import PropTypes from "prop-types"
import React from "react"
import { Container } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"
import { useAuth } from "hooks/authHook"
import QuotationAddEdit from "pages/QuotationPages/QuotationAddEdit"

const Dashboard = props => {
  //meta title
  document.title = "Dashboard | Aurobil Cars"
  const { user } = useAuth()
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />
          {user?.name ? (
            <p>
              Welcome! <strong>{user.name}</strong>
            </p>
          ) : (
            ""
          )}
          <QuotationAddEdit/>
        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Dashboard)
